window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      updateSwatchVariant(variant);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }

      updateSwatchVariant(variant);

    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  function updateSwatchVariant(variant) {
    // BEGIN SWATCHES
    if (variant) {
      var form = jQuery('form[action="/cart/add"]');
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
        if (radioButton && radioButton.get(0)) {
          radioButton.get(0).checked = true;
        }
      }
    }
    // END SWATCHES
  }

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    mobileCarouselBp : 800
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    // init product carousel on mobile
    if ($(window).width() < selectors.mobileCarouselBp) {
      $('.product-images').imagesLoaded( function() {
        $carousel = $('.product-images').flickity({
          cellAlign: 'center',
          prevNextButtons: false,
          contain: true
        });
      });
    }

    $(selectors.addToCart).on('click', function() {
      //console.log('add to cart', $(selectors.originalSelectorId).val());
      var tva_rate = $(this).attr("tva_rate");
      CartJS.addItem($(selectors.originalSelectorId).val(), 1, {"tva_rate": tva_rate }, {
        // Define a success callback to display a success message.
          "success": function(data, textStatus, jqXHR) {
            //console.log("sucess");
          },
          // Define an error callback to display an error message.
          "error": function(jqXHR, textStatus, errorThrown) {
            console.log("error", textStatus, errorThrown);
          }
      });
      return false;
    });


  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

$(function() {
    /**
    * Smooth scrolling to page anchor on click
    **/
    $("a[href*='#']:not([href='#'])").click(function() {
        if (
            location.hostname == this.hostname
            && this.pathname.replace(/^\//,"") == location.pathname.replace(/^\//,"")
        ) {
            var anchor = $(this.hash);
            anchor = anchor.length ? anchor : $("[name=" + this.hash.slice(1) +"]");
            if ( anchor.length ) {
                $("html, body").animate( { scrollTop: anchor.offset().top - 100 }, 1000);
            }
        }
    });
});

$('.faqs__btn, .faqs__text').on('click', function() {
	var parentId = $(this).parent().attr('id');
	console.log("parentId: ", parentId);
	$('#' + parentId + ' .down-arrow').toggleClass('faqs__active');
	$('#' + parentId + ' .faqs__text .faqs__description').slideToggle();
});
$('.collection__active-filters, .collection__hide-filters, .collection__cross-filters').on('click', function() {
	$('.collection__filters').toggleClass('active--filters');
	$('.collection__hide-filters').toggleClass('active--filters');
})

$('.collection__show-more-filters').on('click', function() {
	$(this).parent().children().show();
	$(this).hide();
})

$('.collection__show-less-filters').on('click', function() {
	console.log("Debug");
	$(this).parent().children("li:nth-child(n+4)").hide();
	$(this).parent().children("span").show();
	$(this).hide();
})

theme.collection = new function() {
	var settings = {};
  
	function collection(collectionSettings) {
	  // init default settings
	  var defaultSettings = {
		collectionSelector : '[data-collection-carousel]'
	  };
	  // merge settings
	  settings = $.extend({}, defaultSettings, collectionSettings);
  
	  $(settings.collectionSelector).imagesLoaded( function() {
		var $collectionCarousel = $(settings.collectionSelector).flickity({
		  cellAlign: 'left',
		  contain: true,
		  prevNextButtons: false,
		  watchCSS: true
		});
	  });
  
	}
  
	return collection;
}
  
var collection = new theme.collection();

theme.lookbook = new function() {
	var settings = {};

	function lookbook(lookbookSettings) {
	  // init default settings
	  var defaultSettings = {
		lookbookSelector : '[data-lookbook-carousel]'
	  };
	  // merge settings
	  settings = $.extend({}, defaultSettings, lookbookSettings);

	  $(settings.lookbookSelector).imagesLoaded( function() {
		var $lookbookCarousel = $(settings.lookbookSelector).flickity({
		  cellAlign: 'left',
		  contain: true,
		  pageDots: false,
		  prevNextButtons: true,
		  watchCSS: true
		});

		var $cellButtonGroup = $('.lookbook__button-list');
		var $cellButtons = $cellButtonGroup.find('.lookbook__index');

		// update selected cellButtons
		$lookbookCarousel.on('change.flickity', function(event, index) {
			$cellButtons.filter('.lookbook__index-selected').removeClass('lookbook__index-selected');
			$cellButtons.eq(index).addClass('lookbook__index-selected');
		});

		// select cell on button click
		$cellButtonGroup.on('click', '.lookbook__index', function() {
			var index = $(this).index();
			$lookbookCarousel.flickity( 'select', index );
			$cellButtons.filter('.lookbook__index-selected').removeClass('lookbook__index-selected');
			$cellButtons.eq(index).addClass('lookbook__index-selected');
		});

	  });

	}

	return lookbook;
}

var lookbook = new theme.lookbook();

theme.articleProducts = new function() {
	function articleProducts() {
		var settings = {
			imageContainerSelector : '[data-article-caroussel]',
			carousselSelector : '[data-article-caroussel]',
			actionButtonSelector : '[data-action-button-caroussel]'
		};

		$(settings.imageContainerSelector).imagesLoaded( function() {
			$carousel = $(settings.carousselSelector).flickity({
				pageDots: false,
				prevNextButtons: false
			});

			$(settings.actionButtonSelector).on( 'click', '.article-action-button', function() {
				var index = $(this).index();
				$carousel.flickity( 'select', index, false, true );
			});
		});
	}
	return articleProducts;
}
var articleProducts = new theme.articleProducts();

$('.stores__link').on('click', function() {
	$('.stores__blocks').toggle();
});
theme.searchBar = new function() {

  var settings = {
    openSelector : '[data-search-bar-open]',
    closeSelector : '[data-search-bar-close], main',
    searchBar : '[data-search-bar]',
    inputBar : '[data-search-bar-input]',
    result : '[data-search-result]',
    activeClass : 'active',
    highlightClass : 'highlight'
  };


	function searchBar() {
    $(settings.inputBar).keyup(function( event ) {
      if (this.value.length > 0)
        searchProduct(this.value);
    });
    $(settings.openSelector).on('click', function(e) {
      openSearch();
      // close side nav
      $('.side-nav').removeClass('active');
      return false;
    });
    $(settings.closeSelector).on('click', function() {
      closeSearch();
      $(settings.result).removeClass(settings.activeClass);
      $(settings.searchBar).removeClass(settings.highlightClass);
    });
	}


  function searchProduct(search) {
    $.get('/search?view=ajax&q=' + search + '*&type=product', function( data ) {
      $(settings.result).html(data);
      $(settings.searchBar).addClass(settings.highlightClass);
      $(settings.result).addClass(settings.activeClass);
    });

  }


  function openSearch() {
    $(settings.searchBar).addClass(settings.activeClass);
  }
  function closeSearch() {
    $(settings.searchBar).removeClass(settings.activeClass);
  }


	return searchBar;
}

var searchBar = new theme.searchBar();

$('.order__return').on('click', function() {
    var parentId = $(this).parent().parent().attr('id');
    if ($('#' + parentId + ' .contact-orders').is(":visible")) {
        $('#' + parentId + ' .contact-orders').toggle();
    }
    $('#' + parentId + ' .contact-return').slideToggle();
});

$('.orders__contact').on('click', function() {
    var parentId = $(this).parent().parent().attr('id');
    if ($('#' + parentId + ' .contact-return').is(":visible")) {
        $('#' + parentId + ' .contact-return').toggle();
    }
    $('#' + parentId + ' .contact-orders').slideToggle();
});
theme.articleShare = new function() {
	function articleShare() {
		var settings = {
            blockPictosSelector : '[data-block-share-pictos]',
			sharePictosSelector : '[data-share-pictos]',
            pictosSelector : '[data-pictos]',
            blockNewsletterSelector : '[data-block-share-newsletter]',
            showNewsletterSelector : '[data-show-newsletter]',
            newsletterInputSelector : '[data-newsletter-input]',
        };
        
        $(settings.sharePictosSelector).on('click', function() {
            $(this).toggle();
            $(settings.pictosSelector).toggle();
            $(settings.blockNewsletterSelector).toggle();
        });

        $(settings.showNewsletterSelector).on('click', function() {
            $(this).toggle();
            $(settings.blockPictosSelector).toggle();
            $(settings.newsletterInputSelector).toggle();
        });
	}
	return articleShare;
}
var articleShare = new theme.articleShare();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#address__new-form');
  var $addressDetails = $('#address__details');

  if (!$newAddressForm.length && !$addressDetails.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
    $addressDetails.toggle();
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
    $('.address__block-content--'+ formId).toggle();
    $('.address-new-toggle').toggle();
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

/*================ Custom ================*/

theme.banner = new function() {

  var settings = {};

  function banner(bannerSettings) {

    var defaultSettings = {
      headerSelector : '#shopify-section-header',
      bannerSelector : '[data-banner]',
      selectorData : 'banner',
      prevNextButtons : false,
      pageDots : false
    };

    $(document).ready(function(){
      resizeWindow();
    });

    window.addEventListener('resize', function () {
      resizeWindow();
    });

    settings = $.extend({}, defaultSettings, bannerSettings);

    $(settings.bannerSelector).each(function() {

      var el = $(this);

      $(this).imagesLoaded( function() {
        var elementSettings = $(el).data(settings.selectorData);
        var finalSettings = $.extend({}, settings, elementSettings);

        $(el).flickity({
          lazyLoad: 'true',
          pageDots: finalSettings.pageDots,
          prevNextButtons: finalSettings.prevNextButtons
        });
      });

    });
  }

  function resizeWindow() {
    var windowWidth = window.innerWidth,
        headerSection = $(settings.headerSelector);

    document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
    if (headerSection) {
      document.documentElement.style.setProperty('--header-height', headerSection.height() + 'px');
    }
  };

  return banner;
}

var banner = new theme.banner();



/** header **/

theme.header = new function() {
  var settings = {};

  function header(headerSettings) {

    // init default settings
    var defaultSettings = {
      headerId : "shopify-section-header",
      headerSelector : '.header',
      headerTransparent : 'header--transparent',
      toggleSideNav : '[data-header-toggle]',
      sideNavSelector : '[data-header-side-nav]',
      openSideNavClass : 'active',
      lightClass : 'light',
      openSubmenuSideNavSelector : '[data-open-side-nav-submenu]',
      headerNotLight : 'not-light'
    };

    // merge settings
    settings = $.extend({}, defaultSettings, headerSettings);

    $(window).on("scroll", function() {
      if($(window).scrollTop() > 100) {
          $(settings.headerSelector).addClass("little");
      } else {
         $(settings.headerSelector).removeClass("little");
      }
    });

    if ($(settings.headerSelector).hasClass('header--transparent')) {
      checkHeaderStatus();
      $(window).on("scroll", function() {
        checkHeaderStatus();
      });
    }

    $(settings.toggleSideNav).on('click', function() {
      toggleSideNav();
    });

    resizeWindow();
    window.addEventListener('resize', function () {
      resizeWindow();
    });

    $(settings.openSubmenuSideNavSelector).on('click', function() {
      $(this).parent().parent().find('.side-nav__submenu').slideToggle();
      $(this).toggleClass('active');
    });
  }

  function openSideNav() {
    $(settings.sideNavSelector).addClass(settings.openSideNavClass);
    $(settings.headerSelector).addClass(settings.headerNotLight);
  }

  function closeSideNav() {
    $(settings.sideNavSelector).removeClass(settings.openSideNavClass);
    $(settings.headerSelector).removeClass(settings.headerNotLight);
  }

  function toggleSideNav() {
    if ($(settings.sideNavSelector).hasClass(settings.openSideNavClass))
      closeSideNav();
    else
      openSideNav();
  }

  function checkHeaderStatus() {
    if($(window).scrollTop() > 50) {
        $(settings.headerSelector).removeClass("light");
    } else {
       $(settings.headerSelector).addClass("light");
    }
  }

  function resizeWindow() {
    var windowWidth = window.innerWidth,
        headerSection = document.getElementById(settings.headerId);
    document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
    if (headerSection) {
      document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
      document.documentElement.style.setProperty('--header-height-real', $(settings.headerSelector).height() + 'px');
    }
  };

  return header;
}

var header = new theme.header();



/** side cart **/

theme.cart = new function() {

  var settings = {};

  function cart(cartSettings) {

    // init default settings
    var defaultSettings = {
      openCartSelector : "[data-cart-open]",
      toggleCartSelector : "[data-cart-toggle]",
      closeCartSelector : "[data-cart-close]",
      cartSelector : "[data-side-cart]",
      cartCountSelector : "[data-cart-count]",
      cartItemSelector : '[data-cart-item]',
      cartItemsSelector : '[data-cart-items]',
      cartItemRemoveSelector : '[data-cart-item-remove]',
      cartTotalPriceSelector : '[data-cart-total-price]',
      cartFooterSelector : '[data-cart-footer]',
      updateCartSelector : '[data-add-to-cart]',
      backgroundSelector : "[data-cart-background-overlay]",
      openCartClass : 'open',
      activeBackgroundClass : "active",
      emptyCartText : '<div class="cart__empty-state heading z-h20">Your cart is empty</div>',
      headerSelector : '.header',
      headerNotLight : 'not-light'
    };
    // merge settings
    settings = $.extend({}, defaultSettings, cartSettings);

    // init cart
    $(document).on('cart.ready', function(event, cart) {
      constructCart(cart, false);
    });

    // call classic function on click on trigger elemets
    $(settings.toggleCartSelector).on('click', function() {
      toggleCart();
      return false;
    });

    $('body').on('click', settings.closeCartSelector, function() {
      closeCart();
      return false;
    });

    $(settings.openCartSelector).on('click', function() {
      openCart();
      return false;
    });

    $(document).on('cart.requestComplete', function(event, cart) {
        constructCart(cart, true);
      console.log("ERERER");
    });
  }

  function getPrice(price, cart, tva_rate) {
    var price = Number(price * tva_rate / 100).toFixed(2);
    if (cart.currency == "EUR")
      return price + "€";
    else
      return price + "$";
  }

  function constructCart(cart, open) {
    // create elemets
    var contexts = [];
    var context = {};
    var c = null;
    var final_html = "";
    var source = "";
    var template = null;
    var total_price = 0;


    for(var i=0, l=cart.items.length; i<l; i++) {
      c = cart.items[i];
      var context = {
        item_image : c.image,
        item_variant_title : c.variant_title,
        item_variant_id : c.variant_id,
        item_product_title : c.product_title,
        item_price : getPrice(c.price, cart, c.properties.tva_rate),
        item_quantity : c.quantity,
        item_quantity_plus : c.quantity + 1,
        item_quantity_minus : c.quantity - 1,
        item_line_price : getPrice(c.line_price, cart, c.properties.tva_rate),
        item_url :  c.url
      };
      console.dir(c)
      console.log("TAg->" + c);
      total_price = parseFloat(total_price) + parseFloat(context.item_line_price);
      source = $(settings.cartItemSelector).html();
      template = Handlebars.compile(source);
      html = template(context);
      final_html += html;
    }

    $(settings.cartCountSelector).html(cart.items.length);
    cart.items.length > 0 ? $(settings.cartCountSelector).fadeIn().css("display","inline-block") : $(settings.cartCountSelector).fadeOut();

    $(settings.cartTotalPriceSelector).html(getPrice(total_price * 100, cart, 1));

    if (cart.items.length > 0) {
      $(settings.cartItemsSelector).html(final_html);
      $('.cart-subheader').remove();

      var textFreeShipping = ""
      if (cart.total_price > 35000)
        textFreeShipping = '<div class="cart-subheader"><p class="z-h20">Free exchanges and returns<br/>You are eligible for free shipping</p></div>';
      else
        textFreeShipping = '<div class="cart-subheader"><p class="z-h20">Free exchanges and returns</p></div>';
      $(settings.cartItemsSelector).prepend(textFreeShipping);
    }
    else {
      $(settings.cartItemsSelector).html(settings.emptyCartText);
      $('.cart-subheader').remove();
    }

    if (open)
      openCart();
    
    if ($('body').hasClass("template-product")) {
      $("[data-cart-remove-id]").on('click', function() {
        CartJS.removeItemById($(this).attr("data-cart-remove-id"));
      });
      $("[data-cart-update-id]").on("click", function() {
        CartJS.updateItemById($(this).attr("data-cart-update-id"), $(this).attr("data-cart-quantity"));
      });
    }
  }

  function openCart() {

    if ($('body').hasClass('template-cart')) return;

    $(settings.cartSelector).addClass(settings.openCartClass);
    $(settings.backgroundSelector).addClass(settings.activeBackgroundClass);
    $(settings.headerSelector).addClass(settings.headerNotLight);
  }

  function closeCart() {
    $(settings.cartSelector).removeClass(settings.openCartClass);
    $(settings.backgroundSelector).removeClass(settings.activeBackgroundClass);
    $(settings.headerSelector).removeClass(settings.headerNotLight);
    if ($('body').hasClass('template-cart'))
      window.location.href = "/";

  }

  function toggleCart() {
    if ($(settings.cartSelector).hasClass(settings.openCartClass))
      closeCart();
    else
      openCart();
  }

  return cart;
}

var cart = new theme.cart();




/** scroll reveal ***/

theme.sr = new function() {

  var settings = {};

  function sr(srSettings) {

    // init default settings
    var defaultSettings = {
      selector: '[data-sr]',
      selectorData : 'sr',
      delay: 500,
      duration: 500,
      distance: '1000px',
      origin: 'bottom',
      reset: false,
      mobile : false
    };
    settings = $.extend({}, defaultSettings, srSettings);

    $(settings.selector).each(function() {

      var elementSettings = $(this).data(settings.selectorData);

      // console.log(elementSettings);

      var finalSettings = $.extend({}, settings, elementSettings);
      // scroll reveal
      // console.log(finalSettings);

      ScrollReveal().reveal($(this), {
        delay: finalSettings.delay,
        duration: finalSettings.duration,
        distance: finalSettings.distance,
        origin: finalSettings.origin,
        reset: finalSettings.reset,
        mobile : finalSettings.mobile
      });
    });

  }

  return sr;
}

var sr = new theme.sr();



/** sizeChart **/

theme.sizeChart = new function() {

  var settings = {};

  function sizeChart(sizeChartSettings) {

    // init default settings
    var defaultSettings = {
      openSizeChart : "[data-size-chart-open]",
      toggleSizeChart : "[data-size-chart-toggle]",
      closeSizeChart : "[data-size-chart-close]",
      sizeChart : "[data-size-chart]",
      openClass : 'open',
      changeTabSelector : '[data-change-tab]'
    };
    // merge settings
    settings = $.extend({}, defaultSettings, sizeChartSettings);


    // call classic function on click on trigger elemets
    $(settings.toggleSizeChart).on('click', function() {
      toggleSizeChart();
      return false;
    });

    $(settings.closeSizeChart).on('click', function() {
      closeSizeChart();
      return false;
    });

    $(settings.openSizeChart).on('click', function() {
      openSizeChart();
      return false;
    });

    $(settings.changeTabSelector).on('click', function() {
      var index = $(this).data('change-tab');

      $(settings.changeTabSelector).removeClass('active');
      $(this).addClass('active');
      $("[data-tab]").fadeOut(0);
      if ($(window).width() > 800) {
        if (index == "2") {
          $('.hide[data-tab="' + index + '"]').fadeIn(600);
          $('[data-tab="' + index + '"]:first-child').fadeIn(600);
        } else {
          $('[data-tab="' + index + '"]').fadeIn(600);
        }
      }
    });

  }

  function openSizeChart() {
    $(settings.sizeChart).addClass(settings.openClass);
  }

  function closeSizeChart() {
    $(settings.sizeChart).removeClass(settings.openClass);
  }

  function toggleSizeChart() {
    if ($(settings.sizeChart).hasClass(settings.openClass))
      closeSizeChart();
    else
      openSizeChart();
  }

  return sizeChart;
}

var sizeChart = new theme.sizeChart();
